import { validateEstonianIdNumber } from './estonia/estomian-id-number';
import { validateLithuaniaIdCard } from './lithuania/lithuania-id-number';
import { markets, validationCodes } from '../../constants';
import { getValidationMessage } from '../allHelpers';
import { IAppState, IFormControl } from '../../types';

export function validateIdNumber(ctrl: IFormControl, appState: IAppState) {
    const control = ctrl;
    // to prevent overriding of the previous rule
    if (!control.isValid) {
        return;
    }

    switch (appState.formMeta.market) {
        case markets.estonia: {
            const docType = validateEstonianIdNumber(control.value);
            control.isValid = Boolean(docType);

            if (control.isValid) {
                const controlName = control.controlName.split('.');
                const controlNameToFind =
                    controlName.length > 1
                        ? `${controlName[0]}.identificationDocumentType`
                        : 'identificationDocumentType';

                const docNumberTypeControl = appState.controlsState[controlNameToFind];

                if (docNumberTypeControl && Array.isArray(docNumberTypeControl.options)) {
                    const option: any = ((docNumberTypeControl.options as any[]) || []).find(
                        (o) => o.value === docType,
                    );

                    if (option) {
                        docNumberTypeControl.value = option.value;
                    }
                }
            }

            break;
        }

        case markets.lithuania:
            control.isValid = validateLithuaniaIdCard(control.value);
            break;

        default:
            return;
    }

    if (!control.isValid) {
        control.validationMessage = getValidationMessage(control, validationCodes.invalid);
    }
}
